@if (cancelName) {
  <button (click)="cancel.emit()" class="no" color="warn" mat-raised-button type="button">
    <mat-icon>close</mat-icon>
    <span>{{ cancelName }}</span>
  </button>
}
@if (actionName) {
  <button (click)="action.emit()" [disabled]="disableReason" [type]="actionType" color="primary"
    mat-raised-button>
    @if (actionIcon) {
      <mat-icon>{{ actionIcon }}</mat-icon>
    }
    <span>{{ actionName }}</span>
  </button>
}
